import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { BOOKSY_URL } from "@/lib/config";
import { Instagram, MapPin, Calendar } from "lucide-react";

export default function Contact() {
  const [info, setInfo] = useState(null);
  useEffect(() => {
    api.get("/contact").then((r) => setInfo(r.data)).catch(() => {});
  }, []);

  if (!info) return null;

  return (
    <section id="contact" className="bg-[#0C0C0C] py-24 md:py-32 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-7">
            <div className="flex items-center gap-3 mb-4">
              <span className="h-px w-12 bg-[#FF3333]" />
              <span className="text-xs tracking-[0.3em] uppercase font-bold text-[#FF3333]">06 — Pull Up</span>
            </div>
            <h2 className="font-display font-black uppercase text-5xl md:text-7xl tracking-tighter leading-[0.9] mb-8">
              Ready for your<br />
              <span className="italic text-[#FF3333]">fresh cut?</span>
            </h2>
            <p className="text-white/70 font-light text-lg leading-relaxed mb-8 max-w-xl">
              Real-time availability on Booksy. Book 24/7 from any device — no calls, no
              waitlists, just sharp cuts.
            </p>
            <a
              data-testid="contact-book-btn"
              href={BOOKSY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-[#FF3333] text-black font-bold uppercase tracking-widest text-sm px-10 py-5 street-btn hover:bg-[#FF5C5C] transition-colors"
            >
              Book on Booksy →
            </a>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-14">
              <div className="border-l border-[#FF3333]/40 pl-5">
                <div className="text-xs tracking-[0.25em] uppercase text-[#FF3333] mb-2">Location</div>
                <a
                  href="https://www.google.com/maps/search/?api=1&query=2006+Prairie+Rd+Monroe+LA+71202"
                  target="_blank"
                  rel="noreferrer"
                  className="text-white/80 hover:text-white leading-relaxed flex items-start gap-2"
                >
                  <MapPin className="w-4 h-4 mt-1 shrink-0" />
                  <span>{info.address}</span>
                </a>
              </div>
              <div className="border-l border-[#FF3333]/40 pl-5">
                <div className="text-xs tracking-[0.25em] uppercase text-[#FF3333] mb-2">Booksy</div>
                <a
                  href={BOOKSY_URL}
                  target="_blank"
                  rel="noreferrer"
                  className="text-white/80 hover:text-white flex items-center gap-2"
                >
                  <Calendar className="w-4 h-4" /> mcnealcutz.booksy.com
                </a>
              </div>
              <div className="border-l border-[#FF3333]/40 pl-5">
                <div className="text-xs tracking-[0.25em] uppercase text-[#FF3333] mb-2">Instagram</div>
                <a
                  href="https://www.instagram.com/mcnealcutz/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-white/80 hover:text-white flex items-center gap-2"
                >
                  <Instagram className="w-4 h-4" /> {info.instagram}
                </a>
              </div>
              <div className="border-l border-[#FF3333]/40 pl-5">
                <div className="text-xs tracking-[0.25em] uppercase text-[#FF3333] mb-2">Walk-ins</div>
                <div className="text-white/80">Welcome when chairs are open</div>
              </div>
            </div>
          </div>

          <div className="md:col-span-5">
            <div className="border border-white/10 bg-[#050505] p-8">
              <div className="text-xs tracking-[0.3em] uppercase text-[#FF3333] mb-6">Availability</div>
              <div className="space-y-5">
                <div className="flex items-start gap-3">
                  <Calendar className="w-5 h-5 text-[#FF3333] mt-1 shrink-0" />
                  <div>
                    <div className="font-display text-xl font-bold uppercase tracking-tight mb-1">
                      Live on Booksy
                    </div>
                    <p className="text-white/60 text-sm font-light leading-relaxed">
                      All current openings are managed on Booksy — pick your service, time, and
                      lock it in.
                    </p>
                  </div>
                </div>
                <a
                  href={BOOKSY_URL}
                  target="_blank"
                  rel="noreferrer"
                  className="block border border-[#FF3333]/40 text-[#FF3333] hover:bg-[#FF3333] hover:text-black uppercase tracking-widest text-xs font-bold text-center py-4 transition-colors"
                >
                  See available times →
                </a>
                <div className="text-xs text-white/40 leading-relaxed pt-2">
                  Need to reschedule or cancel? Manage it anytime from your Booksy account.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
